import{dew}from"glob.js";export default dew();